// client/src/App.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { NotificationProvider } from './contexts/NotificationContext';
import { AudioProvider } from './contexts/AudioContext';

// Layout
import MainLayout from './components/layout/MainLayout';
import ProtectedRoute from './components/auth/ProtectedRoute';

// Pages
import EntryScreen from './pages/Home/EntryScreen';
import Dashboard from './pages/Home/Dashboard';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import ResetPassword from './pages/Auth/ResetPassword';
import NotFound from './pages/NotFound';
import MyCollection from './pages/Collection/MyCollection';
import CardDetails from './pages/Collection/CardDetails';
import MyDecks from './pages/Deck/MyDecks';
import DeckBuilder from './pages/Deck/DeckBuilder';
import Matchmaking from './pages/Game/Matchmaking';
import Battlefield from './pages/Game/Battlefield';
import Shop from './pages/Shop/Shop';
import Marketplace from './pages/Shop/Marketplace';
import Profile from './pages/User/Profile';
import Rankings from './pages/User/Rankings';
import CampaignMap from './pages/Campaign/CampaignMap';

// Styles
import './styles/global.css';
import RematchBridge from './components/game/RematchBridge'; // R34cc

function App() {
  return (
    <NotificationProvider>
      <AudioProvider>
        <Routes>
          {/* Page d'entrée */}
          <Route path="/" element={<EntryScreen />} />
          
          {/* Dashboard et autres routes protégées par le layout */}
          <Route path="/dashboard" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
          </Route>
          
          <Route path="/" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
            <Route path="collection" element={<MyCollection />} />
            <Route path="collection/:cardId" element={<CardDetails />} />
            <Route path="decks" element={<Navigate to="/collection?tab=decks" replace />} />
            <Route path="decks/builder" element={<DeckBuilder />} />
            <Route path="decks/builder/:deckId" element={<DeckBuilder />} />
            
            {/* Routes de jeu modifiées */}
            <Route path="game/matchmaking" element={<Matchmaking />} />
          <Route path="campaign" element={<CampaignMap />} />
            <Route path="game/battle/ai" element={<Battlefield />} />
            <Route path="game/battle/:gameId" element={<Battlefield />} />
            
            <Route path="shop" element={<Shop />} />
            <Route path="marketplace" element={<Marketplace />} />
            <Route path="profile" element={<Profile />} />
            <Route path="rankings" element={<Rankings />} />
          </Route>
          
          {/* Routes d'authentification — chemins canoniques /auth/* + alias
              historiques /login et /register (MainLayout pointe dessus) */}
          <Route path="/auth/login" element={<Login />} />
          <Route path="/auth/register" element={<Register />} />
          <Route path="/auth/reset-password" element={<ResetPassword />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          
          {/* Route 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        {/* R34cc : défis de revanche PvP — modal + démarrage depuis n'importe quel écran */}
        <RematchBridge />
      </AudioProvider>
    </NotificationProvider>
  );
}

export default App;